var _style, _defs, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000013194345090822203090000001979904827433838481_);}\n\t.st1{fill:#F3F2F0;}\n\t.st2{fill:#DA1C4B;}\n\t.st3{fill:#233B8E;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 256,
    cy: 256,
    r: 256
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108279055808664948520000013421223522693392797_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "flat",
    style: {
      clipPath: "url(#SVGID_00000108279055808664948520000013421223522693392797_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-97.5,0h707v512h-707V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.7,0h170.7v170.7H170.7V0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.7,341.3h170.7V512H170.7V341.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M609.5,170.7v170.7h-707V170.7H609.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.2,207.2h24.4v24.4h-24.4V207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.2,280.4h24.4v24.4h-24.4V280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.4,207.2h24.4v24.4h-24.4V207.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.4,280.4h24.4v24.4h-24.4V280.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.3,243.8h24.4v24.4h-24.4V243.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.3,243.8h24.4v24.4h-24.4V243.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAn);
export default __webpack_public_path__ + "static/media/an.5b23f51c45805ce40ec6b331af8039bb.svg";
export { ForwardRef as ReactComponent };